<p>payment-collection works!</p>
